const VARIABLE_SPAN_PATTERN =
  /<span([^>]*data-variable="([^"]+)"[^>]*)>[\s\S]*?<\/span>/gi;
const VARIABLE_TOKEN_PATTERN = /\{\{\s*([^{}]+?)\s*\}\}/g;

export function findUnresolvedAddendumVariables(html: string): string[] {
  const unresolved = new Set<string>();
  const spanMatches = Array.from((html || "").matchAll(VARIABLE_SPAN_PATTERN));
  spanMatches.forEach((spanMatch) => {
    const value = spanMatch[1].match(/data-variable-value="([^"]*)"/i)?.[1];
    if (!value?.trim()) unresolved.add(spanMatch[2].trim());
  });
  const withoutVariableSpans = (html || "").replace(VARIABLE_SPAN_PATTERN, "");
  const tokenMatches = Array.from(
    withoutVariableSpans.matchAll(VARIABLE_TOKEN_PATTERN)
  );
  tokenMatches.forEach((tokenMatch) => {
    unresolved.add(tokenMatch[1].trim());
  });
  return Array.from(unresolved).sort();
}
